/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-06-05 16:31:27
 * @FilePath: \hippo-web-admin\src\lang\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
//页面中自定义变量
import en from './en';
//ele-admin自带多语言配置
import enLocale from 'ele-admin/packages/lang/en';
import store from '@/store';

Vue.use(VueI18n);

const messages = {
  en: {
    ...en,
    ...enLocale
  }
};

const defaultLang = 'en';
const getDefaultLang = () => {
  const lang = defaultLang;
  const localLang = localStorage.getItem('hippoWebLang');
  let result = defaultLang;
  if (lang.indexOf(defaultLang) > -1) result = defaultLang;
  localStorage.setItem('hippoWebLang', localLang || result);
  store.commit('SET_LANGUAGE', localLang || result);
  return localLang || result;
};
const i18n = new VueI18n({
  locale: getDefaultLang(), //从localStorage中拿到用户的语言选择，如果没有，那默认英文。
  messages,
  silentTranslationWarn: true
});
locale.i18n((key, value) => i18n.t(key, value)); //为了实现element插件的多语言切换
export default i18n;
